import(/* webpackMode: "eager" */ "/codebuild/output/src2163433464/src/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Manrope\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-manrope\"}],\"variableName\":\"manrope\"}");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/codebuild/output/src2163433464/src/app/node_modules/nuqs/dist/adapters/next/app.js");
;
import(/* webpackMode: "eager", webpackExports: ["AppToaster"] */ "/codebuild/output/src2163433464/src/app/src/components/app-toaster/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientContextBootstrap"] */ "/codebuild/output/src2163433464/src/app/src/components/client-context-bootstrap/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageTrackingBootstrap"] */ "/codebuild/output/src2163433464/src/app/src/components/page-tracking-bootstrap/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThirdPartyIntegrations"] */ "/codebuild/output/src2163433464/src/app/src/components/third-party-integrations/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2163433464/src/app/src/contexts/auth-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CurrencyContextProvider"] */ "/codebuild/output/src2163433464/src/app/src/contexts/currency-context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/codebuild/output/src2163433464/src/app/src/v2/components/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthenticatedUserIpRecorder"] */ "/codebuild/output/src2163433464/src/app/src/v2/containers/AuthenticatedUserIpRecorder.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2163433464/src/app/src/v2/ui/Tooltip/Tooltip.tsx");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src2163433464/src/app/styles/globals.tailwind.css");
